import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';

/**
 * 2190. 発注ダッシュボード（取引先別ランキング）
 * [GET] /workspaces/:identifier/purchase_dashboard/amount_by_business_partner
 */
type Props = {
  identifier: string;
  team_ids?: number[];
  user_ids?: number[];
  payment_context_ids?: number[];
};

export type PurchaseDashboardAmountByBusinessPartner = {
  total_amount: number;
  business_partner_rankings: { name: string; total_amount: number; contracted_amount: number }[];
};

const purchaseDashboardAmountByBusinessPartner = (props: Props): Promise<PurchaseDashboardAmountByBusinessPartner> => {
  return axios.get(`/api/workspaces/${props.identifier}/purchase_dashboard/amount_by_business_partner`, { params: props });
};

export const usePurchaseDashboardAmountByBusinessPartner = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'purchase_dashboard', 'amount_by_business_partner', { ...props }],
    queryFn: () => purchaseDashboardAmountByBusinessPartner(props),
    staleTime: 1000 * 60 * 30,
  });
};
